<template>
  <TolModal
    :title="$t('projects.details.contacts.labels.addTesContact')"
    :submit-button-text="$t('projects.details.labels.save')"
    @close="clearFormAndClose()"
    @submit="save()"
  >
    <template v-slot:body>
      <form>
        <div class="form-group">
          <div class="form-control">
            <tol-type-ahead
              v-if="displaySearch"
              :search-params="{
                url: '/assignments/user-quick-search?excludeNullCommissions=false',
                searchKeys: ['username', 'first_name', 'last_name'],
                objectType: 'tesEmployee'
              }"
              class="blue"
              @select-item="OnTesContactSelect($event)"
            >
              <template v-slot="{ value }">
                <span>{{ value.last_name }}, {{ value.first_name }}</span
                ><span v-if="value.commission_number"> # {{ value.commission_number }}</span>
              </template>
            </tol-type-ahead>
            <div v-else>{{ projectTesContact.last_name }}, {{ projectTesContact.first_name }}</div>
          </div>
        </div>
      </form>
    </template>
  </TolModal>
</template>

<script>
import TolModal from '@/app/components/TolModal';
import TolTypeAhead from '@/app/components/TolTypeAhead';

export default {
  name: 'MapProjectTesContactModal',
  components: {
    TolTypeAhead,
    TolModal
  },
  props: {
    project: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      displaySearch: true,
      projectTesContact: {
        projectReferenceNumber: '',
        user_reference_number: '',
        first_name: '',
        last_name: ''
      }
    };
  },
  computed: {
    formErrors() {
      return this.$store.getters.EventTypeValidationErrors;
    }
  },
  mounted() {
    this.projectTesContact.projectReferenceNumber = this.project.reference_number;
  },
  methods: {
    clearFormAndClose() {
      this.projectTesContact = {
        projectReferenceNumber: '',
        user_reference_number: '',
        first_name: '',
        last_name: ''
      };
      this.$emit('close', this.projectTesContact);
    },
    async save() {
      this.$emit('save', this.projectTesContact);
    },
    OnTesContactSelect(tesContact) {
      this.displaySearch = false;
      this.projectTesContact.projectReferenceNumber = this.project.reference_number;
      this.projectTesContact.first_name = tesContact.first_name;
      this.projectTesContact.last_name = tesContact.last_name;
      this.projectTesContact.user_reference_number = tesContact.reference_number;
    }
  }
};
</script>

<style scoped lang="scss">
.form-group > div {
  margin-bottom: 1rem;
}

.form-row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (min-width: 600px) {
    flex-direction: row;
  }
}

@media only screen and (max-width: 599px) {
  .form-row > div {
    margin-bottom: 1rem;
  }
}
</style>
